import { z } from 'zod'

import type { ZodInfer } from '@mntn-dev/utility-types'

export const CreditBalanceSchema = z.object({
  credits: z.number(),
})

export type CreditBalance = ZodInfer<typeof CreditBalanceSchema>
